export interface ModelExecution {
	readonly effort?: string;
	readonly requestedServiceTier?: string;
	readonly serviceTier?: string;
}

const words = {
	en: { effort: "Effort sent", requested: "requested" },
	"pt-BR": { effort: "Effort enviado", requested: "solicitado" },
	es: { effort: "Effort enviado", requested: "solicitado" },
	fr: { effort: "Effort envoyé", requested: "demandé" },
	it: { effort: "Effort inviato", requested: "richiesto" },
	de: { effort: "Effort gesendet", requested: "angefordert" },
	el: { effort: "Effort που στάλθηκε", requested: "ζητήθηκε" },
};
const speeds: Record<string, string> = {
	default: "Standard",
	priority: "Fast",
	ultrafast: "Ultrafast",
	auto: "Auto",
};

/** Absence is unknown; a requested speed never confirms the speed served. */
export function executionFacts(
	execution: ModelExecution | null | undefined,
	locale: string,
): string[] {
	const text = words[locale as keyof typeof words] ?? words.en;
	const facts: string[] = [];
	if (execution?.effort) facts.push(`${text.effort}: ${execution.effort}`);
	const actual = execution?.serviceTier;
	const requested = execution?.requestedServiceTier;
	if (actual) {
		let speed = `Speed: ${speeds[actual] ?? actual}`;
		if (requested && requested !== actual)
			speed += ` (${text.requested}: ${speeds[requested] ?? requested})`;
		facts.push(speed);
	} else if (requested) {
		facts.push(`Speed ${text.requested}: ${speeds[requested] ?? requested}`);
	}
	return facts;
}
